import * as React from "react"
import FeatureChecklist from "@/components/FeatureChecklist"
import TranspondForm from "@/components/TranspondForm"

const GatedContentForm = ({
  title,
  text,
  checklistItems,
  formTitle,
  formId,
  formUrl,
}) => {
  return (
    <section className="mt-20">
      <div className="container-fluid">
        <div className="row middle-sm between-md">
          <div className="col-xs-12 col-sm-6 col-md-6 mt-10 sm:mt-0 mb-10 sm:mb-0 sm:pt-10 sm:pb-10">
            <h1>{title}</h1>
            <p className="p--lg">{text}</p>
            <FeatureChecklist
              className={""}
              dark={true}
              items={checklistItems}
            />
          </div>
          <div className="col-xs-12 col-sm-5 col-sm-offset-1 col-md-5 gated-content__form">
            <TranspondForm title={formTitle} srcUrl={formUrl} formId={formId} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default GatedContentForm
